<template>
  <div class="ordersSubmit">
    <!-- 提示 -->
    <div class="title w f24 color-black font-weight-b">订单提交确认</div>
    <div class="contener w">
      <!-- 资料内容 -->
      <ul class="color-black f18">
        <li>
          <p class="f20 color-black font-weight-b">联系人信息</p>
        </li>
        <li>
          <span>学校名称：</span>
          <input type="text" placeholder="输入院校名称" v-model="schoolName" />
        </li>
        <li>
          <span>联系电话：</span>
          <input type="text" placeholder="联系电话" v-model="phone" />
        </li>
      </ul>
      <!-- 课程列表 -->
      <p class="title f24 color-black font-weight-b">课程详情</p>
      <div class="order-contener">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <div
          class="order-contener-item"
          v-for="(item, classListIndex) in courseArrye"
          :key="classListIndex"
        >
          <OrderList :item="item" :listObj="listObj" :teacherObj="teacherObj" />
        </div>
      </div>
      <div class="submit-btn" @click="submit">确认提交选课</div>
    </div>
  </div>
</template>

<script>
import OrderList from '../../components/orderList.vue'

export default {
  name: 'ordersSubmit',
  components: {
    OrderList
  },
  data () {
    return {
      schoolName: '',
      phone: '',
      courseArrye: [],
      listObj: {}, // 全部的对象
      teacherObj: {}, // 全部的老师
      spinShow: true,
      setData: null,
      adminPhone: null // 管理员手机号
    }
  },
  async mounted () {
    this.init()
    // 获取平台管理员手机号
    const res = await this.$tkParse.get('/settings/applyRemind')
    // console.log(res.data)
    this.adminPhone = res.data
  },
  methods: {
    async init () {
      await this.getOrder()
      this.spinShow = false
    },
    async getOrder () {
      var setData = JSON.parse(sessionStorage.getItem('order'))
      this.setData = setData
      let courseIdArr = []
      let courseMajorIdArr = []
      setData.forEach((item) => {
        if (item.type === '0') {
          courseMajorIdArr.push(item.id)
        } else {
          courseIdArr.push(item.id)
        }
      })
      let courseArr = await this.$tkParse.post(
        '/web/getAllCourses',
        courseIdArr
      ) // 请求云代码
      courseArr = courseArr.data
      let courseMajorArr = await this.$tkParse.post(
        '/web/getAllCourseMajor',
        courseMajorIdArr
      ) // 请求云代码
      courseMajorArr = courseMajorArr.data
      let obj = {}
      courseArr.forEach((item) => {
        item['type'] = '1'
        obj[item.objectId] = item
      })
      courseMajorArr.forEach((item) => {
        item['type'] = '0'
        obj[item.objectId] = item
      })
      // 获取老师
      let teacherId = []
      for (let key in obj) {
        if (obj[key].teacher) {
          teacherId = teacherId.concat(obj[key].teacher) // 合并数组
        }
      }
      teacherId = [...new Set(teacherId)]
      let teacherArr = await this.$tkParse.post(
        '/web/getAllTeacher',
        teacherId
      ) // 请求云代码
      this.teacherObj = teacherArr.data
      this.listObj = obj
      this.courseArrye = setData
    },
    async submit () {
      if (this.schoolName === '') {
        this.$Message.error({ content: '请输入院校名称' })
        return
      }
      if (!this.testTelNumber(this.phone)) {
        return
      }
      let orderArr = []
      for (let key in this.listObj) {
        if (this.listObj[key].type === '0') {
          orderArr.push({
            courseMajor: this.listObj[key].objectId
          })
        } else {
          orderArr.push({
            course: this.listObj[key].objectId
          })
        }
      }
      let data = {
        school: this.schoolName,
        phone: this.phone,
        type: '1',
        user: this.$store.state.user.objectId,
        orderArr
      }
      // return
      let post = await this.$tkParse.post('/classes/myOrder', data)
      if (post) {
        this.$Message.success('提交成功')
        let obj = await this.$tkParse.getData(
          `/classes/_User/${this.$store.state.user.objectId}`
        )
        let applyNum = obj.applyNum + 1 || 1
        let newOrder = obj.newOrder + 1 || 1
        await this.$tkParse.put(
          `/classes/_User/${this.$store.state.user.objectId}`,
          { applyNum, newOrder }
        )
        // await this.$tkParse.post('/sms/send', { // 给平台管理员发送通知
        //   'phone': this.adminPhone,
        //   'templateId': 'BErCB1',
        //   'vars': {
        //     msg: '您有一个新的院校课程申请。'
        //   }
        // })
        await this.$tkParse.post('/sendMsg/send', { // 给平台管理员发送通知
          phone: this.adminPhone,
          msg: '您有一个新的院校课程申请。'
        })

        await this.deleatCourse()
      } else {
        this.$Message.error('提交失败')
      }
      this.$setFlash('submit', 1)
      this.$back()
    },
    async deleatCourse () {
      let deleatArr = [] // 需要删除的id
      this.setData.forEach((item) => {
        deleatArr.push(item)
      })
      let myCar = await this.$tkParse.getList('/classes/registrationCenter', { // 获取我现在的购物车
        params: {
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })
      if (myCar.length) {
        let myCarCourse = myCar[0].course // 购物车
        let newArr = []
        myCarCourse.forEach((item, index) => {
          let id = this.filterByUserName(deleatArr, item.id) // 我的购物车里面是否有需要删除的id
          if (!id) {
            newArr.push(item)
          }
        })
        await this.$tkParse.put(`/classes/registrationCenter/${myCar[0].objectId}`, { course: newArr })
        this.$store.commit('setCarNum', this.$store.state.carNum + 1) // 刷新购物车数据
      }
    },
    // 根据单个筛选用户编码
    filterByUserName (arr, id) {
      return arr.filter(item => item.id === id)
    },

    testTelNumber (phone) {
      if (!phone || phone === '') {
        this.$Message.error('请输入手机号')
        return false
      }
      if (!/^1[23456789]\d{9}$/.test(phone)) {
        this.$Message.error('手机号码有误，请重新输入')
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
.ordersSubmit {
  background-color: #f5f5f8;
  padding: 20px 0 70px;
}
//提示
.title {
  padding: 30px 0;
}
.contener {
  background-color: #fff;
  padding: 2vw;
  box-sizing: border-box;
}
ul {
  border-bottom: 1px solid #e0e0e0;
  li {
    margin-bottom: 32px;
    span {
      display: inline-block;
      width: 90px;
      margin-right: 20px;
    }
    input {
      width: 380px;
      height: 50px;
      background: #ffffff;
      border: 1px solid #868a99;
      border-radius: 4px;
      padding: 0 14px;
      box-sizing: border-box;
    }
  }
}
.order-contener {
  width: 100%;
  border: 1px solid #e2e2e2;
  box-sizing: border-box;
  .order-contener-item {
    border-top: 1px dotted #e2e2e2;
    &:nth-child(1) {
      border-top: none;
    }
  }
}
.submit-btn {
  width: 240px;
  height: 60px;
  line-height: 60px;
  background: #ea3553;
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 40px;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
}
@media(max-width: 992px) {
  ul {
    li {
      margin-bottom: 32px;
      span {
        margin-bottom: 20px;
      }
      input {
        width: 100% !important;
        height: 50px;
        background: #ffffff;
        border: 1px solid #868a99;
        border-radius: 4px;
        padding: 0 14px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
